import React from "react";
import { useEffect,useContext,useState } from "react";
import { useTranslation } from 'react-i18next';
import { GlobalContext } from '../../GlobalContext';
import { methods } from '../../Validation';
import DatePicker from "react-datepicker"; 
import axios from 'axios';




    

const Body = () => {
   const { t, i18n } = useTranslation();
   const [startDate, setStartDate] = useState(null);
   const [back_end_error,setBack_end_error] = useState(null);
      const { default_country_detail } = useContext(GlobalContext);
           const { default_langage_details } = useContext(GlobalContext);
      const loader = document.getElementById("loder-tive");
       const [showThanks,setSetshowThanks] = useState(true);
              let default_country_detail_data = null;
    let default_language_detail_data =null;
    let country_detils =JSON.parse(localStorage.getItem('country_detils'));
  if(localStorage.getItem('defult_country_details') != null){
    default_country_detail_data = JSON.parse(localStorage.getItem('defult_country_details'));
    default_language_detail_data = JSON.parse(localStorage.getItem('defult_language_details'));
  }

   const parseYYYYMMDDToDate = (dateStr) => {
  if (!dateStr || typeof dateStr !== "string") return null;

  const [y, m, d] = dateStr.split("-").map(Number);
  if (!y || !m || !d) return null;

  return new Date(y, m - 1, d);
};
   const formatDateYYYYMMDD = (date) => {
  if (!date) return "";
console.log(date);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate());
console.log(`${year}-${month}-${day}`);
  return `${year}-${month}-${day}`;
};

   const formatDateMMDDYYYY = (date) => {
  if (!date) return "";
    console.log(date);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
 console.log(`${day}-${month}-${year}`);
  return `${day}-${month}-${year}`;
    };
       const [formData, setFormData] = useState({
           name: '',
           email: '',
           requestedDate:'',
           phoneNumber: '',
           pastor: false,
           churchLeader:false,
           churchLeaderRole:'',
           churchName:'',
           churchAddress:'',
            countryId:localStorage.getItem('default_country_code'),
        
   
         });
           const [formdata_valid_error,setFormDatavalid] = useState({//validName
                 name: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:'The name field is required'}],required:true,error:false,errormsg:null
                 },
                 email: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:'The email field is required'},{keyname:'email',methods:'emailMethods',parmeters:[],errormag:"Please enter a valid email address"}],required:true,error:false,errormsg:null
                 },
                  requestedDate: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:'The Request Date field is required'}],required:true,error:false,errormsg:null
                 },
                 phoneNumber: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:'The phone field is required'}],required:true,error:false,errormsg:null},
                 pastor: {validtion:[{keyname:'required',methods:'requiredMethodsnot',parmeters:[],errormag:'The pastor field is required'}],required:true,error:false,errormsg:null},
                 churchLeader:{validtion:[{keyname:'required',methods:'requiredMethodsnot',parmeters:[],errormag:'The church leader field is required'}],required:true,error:false,errormsg:null},
                 churchLeaderRole:{validtion:[{parmeters:[],errormag:'The church leader role field is required'}],error:false,errormsg:null},
                 churchName: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:'The church name field is required'}],required:true,error:false,errormsg:null},
                 churchAddress: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:'The church Address  field is required'}],required:true,error:false,errormsg:null},
         
               });
          const [loading, setLoading] = useState(true);
           const [error, setError] = useState(null);
   const [cityoptions, setOptionData] = useState([]);
       const { siteName } = useContext(GlobalContext);
    
       let baseUrl = siteName.baseUrl;
       let defult_endpoint = siteName.training_endpoits;
       let webEndpoints = siteName.commonEndpoints;


       const handleChange = (e) => {
            console.log(e);
            let { name, value } = e.target;
           if(name == 'churchLeader'){
             let element = document.getElementById("churchLeader");
             console.log(value);
            if(value == 'true'){
              value = true;
                console.log('test')
                 element.classList.remove("d-none");
            }else{
                 value = false;
              element.classList.add("d-none");
            }
           }
            if(name == 'pastor'){
          
            
            if(value == 'true'){
              value = true;
                            
            }else{
                 value = false;
           
            }
           }
           if(name === 'requestedDate' ){
            console.log(value);
          setStartDate(value);
          
        }
            if (name in formdata_valid_error) {
                if('validtion' in formdata_valid_error[name]){
               
                  let result = null;
                  let newformdata;
                    for (let i = 0; i < formdata_valid_error[name].validtion.length; i++) {
                        if (methods[formdata_valid_error[name].validtion[i].methods]) {
                            result = methods[formdata_valid_error[name].validtion[i].methods](value,formdata_valid_error[name].validtion[i].parmeters); 
                            }
                       if(result == false){
                        formdata_valid_error[name].error = true;
                        formdata_valid_error[name].errormsg = formdata_valid_error[name].validtion[i].errormag;
                        newformdata = formdata_valid_error[name];
                         setFormDatavalid(prev => ({
                        ...prev,
                        [name]:newformdata
                        }));
                        break;
                       }
                       if(result == true){
                        
                          formdata_valid_error[name].error = false;
                        formdata_valid_error[name].errormsg = null;
                        newformdata = formdata_valid_error[name];
                         setFormDatavalid(prev => ({
                        ...prev,
                        [name]:newformdata
                        }));
                       }
    
                }
                
                }
                
     
            }
           console.log('test'+value);
            setFormData(prev => ({
              ...prev,
              [name]: value
            }));
            console.log(formData)
          };

               const handleSubmit = (e) => {
                  e.preventDefault(); 
                  loader.classList.remove('d-none');
                  let value;
                
                  for (const name in formData) {
                      value = formData[name];
                      if (name in formdata_valid_error) {
                      if('validtion' in formdata_valid_error[name]){
                     
                        let result = null;
                        let newformdata;
                          for (let i = 0; i < formdata_valid_error[name].validtion.length; i++) {
                              if (methods[formdata_valid_error[name].validtion[i].methods]) {
                                  result = methods[formdata_valid_error[name].validtion[i].methods](value,formdata_valid_error[name].validtion[i].parmeters); 
                                  }
                             if(result == false){
                              formdata_valid_error[name].error = true;
                              formdata_valid_error[name].errormsg = formdata_valid_error[name].validtion[i].errormag;
                              newformdata = formdata_valid_error[name];
                               setFormDatavalid(prev => ({
                              ...prev,
                              [name]:newformdata
                              }));
                              break;
                             }
                             if(result == true){
                              
                                formdata_valid_error[name].error = false;
                              formdata_valid_error[name].errormsg = null;
                              newformdata = formdata_valid_error[name];
                               setFormDatavalid(prev => ({
                              ...prev,
                              [name]:newformdata
                              }));
                             }
          
                      }
                      
                      }
           
                  }
                      }
          
                      let validation = true;
                       for (const key in formdata_valid_error) {
                          if(formdata_valid_error[key].error == true){
                             validation = false; 
                               loader.classList.add('d-none'); 
                             break;
                          }
                       }
          
                       if(validation){
                                     
                        
                          handleSubmit_axios(formData);
                          
                       }else{
                          loader.classList.add('d-none'); 
                          
                       } 
                };

                const handleSubmit_axios = async (formData) => {
      
        try {
        //  const response = await axios.post(baseUrl+defult_endpoint+'register/student', formData);
 const token =  localStorage.getItem('token');
          let formdata_submit = formData
                 

            const response = await axios.post(baseUrl+'web/request/v1/training', formdata_submit,{
        headers: {
          'Content-Type': 'application/json'
        }
      });
          let data = response;
          

          /*call back data*/
        setFormData({
           name: '',
           email: '',
           requestedDate:'',
           phoneNumber: '',
           pastor: false,
           churchLeader:false,
           churchLeaderRole:'',
           churchName:'',
           churchAddress:'',
            countryId:localStorage.getItem('default_country_code'),
        
   
         });
      if(data.status){
        setSetshowThanks(false);
          loader.classList.add('d-none'); 
      }
      //window.location.reload();
         
        } catch (error) {
          //setErrormsg(error.response.data.message);
            loader.classList.add('d-none'); 
          console.log(error.response.data);
              setBack_end_error(error.response.data.message);
          /*error call back*/
        }
      
    };

return (
       <section className="cfan-form-section">
        <div class="container">
       {showThanks? <form onSubmit={handleSubmit}>
            <div class="heading-form">
                <h3>{t('request_a_training')}</h3>
            </div>
            <div class="form-items-wrapper">
                    {back_end_error !=null? <div class="error">{back_end_error}</div> : ''}
                 <div class="form-intem">
                    <label for="fdate">{t('name')}{formdata_valid_error.name.required? <span>*</span> : ''}</label>
                    <input type="text" onChange={handleChange}  name="name" id="fdate" placeholder={t("name")} />
               {formdata_valid_error.name.error? <div className="error">{formdata_valid_error.name.errormsg}</div> : ''}
                </div>
                 <div class="form-intem">
                    <label for="fdate">{t('Email_Address')}{formdata_valid_error.email.required? <span>*</span> : ''}</label>
                    <input type="text" onChange={handleChange}  name="email" id="fdate" placeholder={t("Email_Address")} />
                  {formdata_valid_error.email.error? <div className="error">{formdata_valid_error.email.errormsg}</div> : ''}
                </div>
                  <div class="form-intem">
                    <label for="fdate">Request {t('Date')}{formdata_valid_error.requestedDate.required? <span>*</span> : ''}</label>
                       <DatePicker selected={ startDate
      ? parseYYYYMMDDToDate(startDate)
      : null} onChange={(date) => handleChange({target:{ value: formatDateYYYYMMDD(date),  name: "requestedDate",  label: formatDateMMDDYYYY(date)  }}) } 
                                              dateFormat="MM-dd-yyyy"
                                               placeholderText="Select date"
                                              isClearable
                                              minDate={new Date()}
                                              showYearDropdown
                                              scrollableMonthYearDropdown
                                              style={{ display: "block" }}
                                            />                  
                                            {formdata_valid_error.requestedDate.error? <div className="error">{formdata_valid_error.requestedDate.errormsg}</div> : ''}
                </div>
                 <div class="form-intem">
                    <label for="fdate">{t('Phone_number')}</label>
                    <input type="text" onChange={handleChange}  name="phoneNumber" id="fdate" placeholder={t("Phone_number")} />
                                       {formdata_valid_error.phoneNumber.error? <div className="error">{formdata_valid_error.phoneNumber.errormsg}</div> : ''}
                </div>
                 <div class="form-intem">
                    <label for="fdate">{t('pastor')}{formdata_valid_error.pastor.required? <span>*</span> : ''}</label>
                       <select name="pastor" onChange={handleChange}  id="pastor">
                       <option value="">{t("pastor")}</option>
                       <option value="true">{t("yes")}</option>
                        <option value="false" selected>{t("no")}</option>
                    </select>
                      {formdata_valid_error.pastor.error? <div className="error">{formdata_valid_error.pastor.errormsg}</div> : ''}
                </div>
                
                   <div class="form-intem">
                    <label for="fdate">{t('churchLeader')}{formdata_valid_error.churchLeader.required? <span>*</span> : ''}</label>
                     <select name="churchLeader" onChange={handleChange} data-id="churchLeader"  id="pastor">
                       <option value="">{t("churchLeader")}</option>
                       <option value="true">{t("yes")}</option>
                        <option value="false" selected>{t("no")}</option>
                    </select>
                       {formdata_valid_error.churchLeader.error? <div className="error">{formdata_valid_error.churchLeader.errormsg}</div> : ''}
                </div>
                   <div class="form-intem churchLeader d-none" id="churchLeader">
                    <label for="fdate">{t('churchLeaderRole')}{formdata_valid_error.churchLeaderRole.required? <span>*</span> : ''}</label>
                    <input type="text" onChange={handleChange}  name="churchLeaderRole" id="fdate" placeholder={t("churchLeaderRole")} />
                             {formdata_valid_error.churchLeaderRole.error? <div className="error">{formdata_valid_error.churchLeaderRole.errormsg}</div> : ''}
                    
                </div>
                   <div class="form-intem">
                    <label for="fdate">{t('churchName')}{formdata_valid_error.churchName.required? <span>*</span> : ''}</label>
                    <input type="text" onChange={handleChange}  name="churchName" id="fdate" placeholder={t("churchName")} />
                       {formdata_valid_error.churchName.error? <div className="error">{formdata_valid_error.churchName.errormsg}</div> : ''}
                </div>
                <div class="form-intem">
                    <label for="fdate">{t('churchAddress')}{formdata_valid_error.churchAddress.required? <span>*</span> : ''}</label>
                                    <textarea onChange={handleChange} value={formData.address} name="churchAddress"></textarea>
                                     {formdata_valid_error.churchAddress.error? <div className="error">{formdata_valid_error.churchAddress.errormsg}</div> : ''}  
                       
                </div>
                   <div class="form-intem">
                    <label for="country">{t("select_country")}</label>
                    <select name="countryId" onChange={handleChange}  id="countryId">
                       {country_detils.map((description, index) => (
                            <option
                              key={index}
                              value={description.value}
                              selected={description.value == localStorage.getItem('default_country_code')? 'selected' : ''}
                            >
                              {description.label}
                            </option>
                          ))}
                    </select>
                     
                </div>
                
                <div class="form-intem form-item-full">
                    <button type="submit">{t("Submit")}</button>
                </div>
            </div>
        </form> : <div className="form-submit-success">
                              {t('New Training Request has been submitted successfully.')}
                            </div>  }
    </div>
</section>
  );
};

export default Body;